import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import RoomList from './pages/RoomList';
import RoomDetail from './pages/RoomDetail';
import CreateRoom from './pages/CreateRoom';
import EditRoom from './pages/EditRoom';
import MyRooms from './pages/MyRooms';
import BookingList from './pages/BookingList';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import Profile from './pages/Profile';
import Projects from './pages/Projects';
import SalerInventory from './pages/SalerInventory';
import CreateDeposit from './pages/CreateDeposit';
import WalletTopUp from './pages/WalletTopUp';
import { authService } from './api/services';
import { LanguageProvider } from './contexts/LanguageContext';

const PrivateRoute = ({ children, roles = [] }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (roles.length > 0) {
    const user = authService.getCurrentUser();
    if (!roles.includes(user?.role)) {
      return <Navigate to="/" />;
    }
  }

  return children;
};

const GuestOnlyRoute = ({ children }) => {
  if (authService.isAuthenticated()) {
    return <Navigate to="/rooms" replace />;
  }

  return children;
};

const DepositEditor = () => {
  const location = useLocation();
  return <CreateDeposit key={location.search} />;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
          <Route path="/" element={<Navigate to="/rooms" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={
            <GuestOnlyRoute>
              <Login />
            </GuestOnlyRoute>
          } />
          <Route path="/register" element={
            <GuestOnlyRoute>
              <Register />
            </GuestOnlyRoute>
          } />
          <Route path="/rooms" element={<RoomList />} />
          <Route path="/rooms/:id" element={<RoomDetail />} />
          <Route path="/projects" element={<PrivateRoute roles={['admin', 'landlord']}><Projects /></PrivateRoute>} />
          <Route path="/inventory" element={<PrivateRoute roles={['saler']}><SalerInventory/></PrivateRoute>}/>
          <Route path="/projects/new" element={<PrivateRoute roles={['admin', 'landlord']}><Projects mode="new" /></PrivateRoute>} />
          <Route path="/projects/:projectId" element={<PrivateRoute roles={['admin', 'landlord']}><Projects mode="edit" /></PrivateRoute>} />
          
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/create-room" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <CreateRoom />
            </PrivateRoute>
          } />
          
          <Route path="/edit-room/:id" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <EditRoom />
            </PrivateRoute>
          } />
          
          <Route path="/my-rooms" element={
            <PrivateRoute roles={['landlord', 'saler', 'admin']}>
              <MyRooms />
            </PrivateRoute>
          } />
          <Route path="/admin/rooms" element={
            <PrivateRoute roles={['admin']}>
              <MyRooms adminMode />
            </PrivateRoute>
          } />
          
          <Route path="/bookings" element={
            <PrivateRoute>
              <BookingList />
            </PrivateRoute>
          } />

          <Route path="/create-deposit" element={
            <PrivateRoute>
              <DepositEditor />
            </PrivateRoute>
          } />
          <Route path="/wallet/top-up" element={
            <PrivateRoute>
              <WalletTopUp />
            </PrivateRoute>
          } />
          
          <Route path="/users" element={
            <PrivateRoute roles={['admin']}>
              <UserList />
            </PrivateRoute>
          } />
          
          <Route path="/profile" element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          } />

            <Route path="*" element={<Navigate to="/rooms" replace />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
